import { createContext, type Context } from "react"

import type { ModuleRenderDependencies } from "../modules/types"

/**
 * Subset of {@link ModuleRenderDependencies} owned by the dashboard and re-applied on each render.
 * OpLayoutEngine embeds Dockview; Dockview does not replace existing panels’ React factories when the
 * registry updates, so values passed only through those closures can go stale without this context.
 */
export type DashboardOpLayoutModuleDependencies = Pick<
  ModuleRenderDependencies,
  "instrumentsWithMetadata" | "hasMultipleInstruments" | "contentSets" | "modelMetadata"
>

export const DashboardOpLayoutModuleDependenciesContext: Context<DashboardOpLayoutModuleDependencies | null> =
  createContext<DashboardOpLayoutModuleDependencies | null>(null)

/**
 * Overlays dashboard-supplied {@link ModuleRenderDependencies} fields onto the panel’s frozen
 * dependencies (see {@link DashboardOpLayoutModuleDependenciesContext}).
 */
export function mergeModuleRenderDependenciesWithDashboardOpLayout(
  panelModuleRenderDependencies: ModuleRenderDependencies,
  dashboardOpLayoutModuleDependencies: DashboardOpLayoutModuleDependencies | null,
): ModuleRenderDependencies {
  if (!dashboardOpLayoutModuleDependencies) {
    return panelModuleRenderDependencies
  }
  return {
    ...panelModuleRenderDependencies,
    ...dashboardOpLayoutModuleDependencies,
  }
}
